import useIndex from '@/views/use/useIndex.vue'

export default {
  path: '/use',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'useIndex',
      name: 'useIndex',
      component: useIndex
    },


  ]
}
